import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";

import { Box, Button, Typography, Card } from "@components/base";

const Help: FC = () => {
  const { t } = useTranslation();
  const { show } = useIntercom();

  return (
    <Card
      sx={{
        minHeight: { md: 360 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        {t("csob.help.title")}
      </Typography>
      <Typography variant="body2">{t("csob.help.description")}</Typography>
      <Box mt={3}>
        <Button variant="outlined" size="medium" onClick={show}>
          {t("csob.help.button")}
        </Button>
      </Box>
    </Card>
  );
};

export default Help;
